var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{attrs:{"name":"Programs & Events","desc":"Create and manage your programs and events","search":"","endpoint":_vm.api.$.program.list,"filter":_vm.defaultFilter,"alias":"programGrid"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-303d32ac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Programs/Program-list/index.vue
// module id = v84C
// module chunks = 12